import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=1124bc48&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=1124bc48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1124bc48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\scpc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1124bc48')) {
      api.createRecord('1124bc48', component.options)
    } else {
      api.reload('1124bc48', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=1124bc48&scoped=true&", function () {
      api.rerender('1124bc48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Process/Index.vue"
export default component.exports